module.exports = __webpack_public_path__ + "img/js.67235794.png";